var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8645_105475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8 15H17.2C13.12 15 10 18.25 10 22.5V47.5C10 51.75 13.12 55 17.2 55H50.8C54.88 55 58 51.75 58 47.5V22.5C58 18.25 54.88 15 50.8 15ZM53.2 39.5L48.64 34.75C45.76 32 41.2 32 38.56 34.75L36.4 37L29.44 29.75C26.56 27 22 27 19.36 29.75L14.8 34.5V22.5C14.8 21 15.76 20 17.2 20H50.8C52.24 20 53.2 21 53.2 22.5V39.5Z",
    fill: "url(#paint0_linear_8645_105475)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8645_105475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8 12H17.2C13.12 12 10 15.25 10 19.5V44.5C10 48.75 13.12 52 17.2 52H50.8C54.88 52 58 48.75 58 44.5V19.5C58 15.25 54.88 12 50.8 12ZM53.2 36.5L48.64 31.75C45.76 29 41.2 29 38.56 31.75L36.4 34L29.44 26.75C26.56 24 22 24 19.36 26.75L14.8 31.5V19.5C14.8 18 15.76 17 17.2 17H50.8C52.24 17 53.2 18 53.2 19.5V36.5Z",
    fill: "url(#paint1_linear_8645_105475)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8393 36.8463L53.7 37.7428V36.5V19.5C53.7 18.6424 53.4239 17.8862 52.9007 17.3412C52.3757 16.7944 51.6399 16.5 50.8 16.5H17.2C16.3601 16.5 15.6243 16.7944 15.0993 17.3412C14.5761 17.8862 14.3 18.6424 14.3 19.5V31.5V32.7428L15.1607 31.8463L19.7207 27.0963C22.1535 24.5621 26.391 24.5377 29.087 27.1042L36.0393 34.3463L36.4 34.722L36.7607 34.3463L38.9207 32.0963C41.3535 29.5621 45.591 29.5377 48.287 32.1042L52.8393 36.8463ZM17.2 12.5H50.8C54.5848 12.5 57.5 15.5067 57.5 19.5V44.5C57.5 48.4933 54.5848 51.5 50.8 51.5H17.2C13.4152 51.5 10.5 48.4933 10.5 44.5V19.5C10.5 15.5067 13.4152 12.5 17.2 12.5Z",
    stroke: "url(#paint2_radial_8645_105475)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8645_105475",
    x: 0,
    y: 5,
    width: 68,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_8645_105475"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8645_105475",
    x: 10,
    y: 8,
    width: 48,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.84 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8645_105475"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8645_105475",
    x1: 40.989,
    y1: 17.7723,
    x2: 33.4187,
    y2: 50.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8645_105475",
    x1: 40.989,
    y1: 14.7723,
    x2: 33.4187,
    y2: 47.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C610"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8645_105475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10 52) rotate(-39.8056) scale(46.4215 45.6605)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17255,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.a5c07efa8f1d02dafec856511e7d164b.svg";
export { ForwardRef as ReactComponent };